

import { Box, Grid, Skeleton, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function DetailedInfo({ DetailInfo, onScrollToInterest }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Box pt={"2%"} sx={{ overflowX: "auto" }}>
      <Typography
        variant="inherit"
        color="gray"
        letterSpacing={2}
        fontFamily="KIAbodyLatinbasic_Regular"
        sx={{
          fontSize: "clamp(14px, 2vw, 16px)",
          px: 2,
          textAlign: "center",
        }}
      >
        DETAILED INFORMATION
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: { xs: 2, sm: 3 },
          pt: 3,
          pb: 3,
          flexWrap: { xs: "wrap", sm: "nowrap" }, // wrap on small screens
          justifyContent: "center",
        }}
      >
        {DetailInfo.map((item, index) => (
          <Box
            key={index}
            sx={{
              minWidth: { xs: "85%", sm: "320px", md: "360px", lg: "400px" },
              maxWidth: { xs: "90%", sm: "320px", md: "360px", lg: "400px" },
              backgroundColor: item.bgColor,
              p: { xs: 2, sm: 3, md: 4 },
              flexShrink: 0,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              // borderRadius: "12px",
              mx: { xs: "auto", sm: 0 },
            }}
          >
            <Link
              to={item.link}
              style={{ textDecoration: "none", color: item.color }}
            >
              {!isLoaded && (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: { xs: "100px", sm: "120px" },
                    height: "auto",
                    marginBottom: "10px",
                  }}
                />
              )}
              <Box
                component="img"
                loading="lazy"
                decoding="async"
                onLoad={() => setIsLoaded(true)}
                src={item.imgSrc}
                alt={item.title}
                sx={{
                  width: { xs: "60px", sm: "60px" },
                  height: "auto",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (index === 0) {
                    onScrollToInterest();
                  }
                }}
              />
              <Typography
                fontFamily="KIAbodyLatinbasic_Bold"
                variant="subtitle2"
                sx={{
                  fontSize: { xs: "14px", sm: "15px" },
                }}
              >
                {item.title}
              </Typography>
              <Typography
                fontFamily="KIAbodyLatinbasic_Regular"
                variant="body2"
                py={0.8}
                sx={{
                  fontSize: { xs: "13px", sm: "14px" },
                }}
              >
                {item.desc}
              </Typography>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
